import { useFormikContext } from "formik";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useEditFormTemplateContext } from "../../context";

export const DirtyFormTracker = () => {
  return (
    <ErrorBoundary fallback={null}>
      {/**
       * Prevent any exception from this component to bubble up
       * since this feature is not actually required
       **/}
      <DirtyFormTrackerInternal />
    </ErrorBoundary>
  );
};

const DirtyFormTrackerInternal = () => {
  const { setFormDirty } = useEditFormTemplateContext();
  const formik = useFormikContext();
  React.useEffect(() => {
    setFormDirty(formik.dirty);
    return () => {
      setFormDirty(false);
    };
  }, [formik.dirty, setFormDirty]);

  return null;
};
